import React, { useRef, useEffect } from 'react';
import Chart from 'chart.js/auto';

const LineChart = ({ data }) => {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!Array.isArray(data) || data.length === 0) return;

    const ctx = canvasRef.current.getContext('2d');

    if (chartRef.current) {
      chartRef.current.destroy();
    }

    chartRef.current = new Chart(ctx, {
      type: 'line',
      data: {
        labels: data.map(item => `Week ${item.week_number}`),
        datasets: [
          {
            label: 'Shooting %',
            data: data.map(item => Math.round((item.shooting_pct ?? 0) * 100)),
            borderColor: '#4caf50',
            backgroundColor: 'rgba(76, 175, 80, 0.2)',
            tension: 0.3,
            fill: true,
            pointRadius: 5,
            pointHoverRadius: 7
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false, // 🔧 Add this
        plugins: {
          legend: { position: 'top' },
          tooltip: {
            callbacks: {
              label: (context) => `${context.parsed.y}%`
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            max: 100,
            ticks: {
              callback: (value) => `${value}%`
            }
          }
        }
      }
    });
  }, [data]);

  return (
    <div style={{ width: '100%', maxWidth: '600px', height: '300px', margin: '0 auto' }}>
      {(!Array.isArray(data) || data.length === 0) ? (
        <p>No chart data available.</p>
      ) : (
        <canvas ref={canvasRef} />
      )}
    </div>
  );
};

export default LineChart;

